import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import Static_Bar_icon from "@/assets/img/Static_Bar_icon.svg";
import Static_Bar_cross from "@/assets/img/Static_Bar_Cross.png";
import { useMedia } from "@commons/media";
import { useTranslation } from "react-i18next";
interface StaticHeaderBarProps {
    mgmCode: string,
    close: () => void;
}

const StaticBarStyles = makeStyles((theme: Theme) => (
    createStyles({
        root: {
            top: 0,
            zIndex: 1001,
            width: '100%',
            backgroundColor: 'rgb(240, 111, 47)',
            padding: '.5rem 1.5rem',
            color: '#fff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        rootUnScrolled: {
            position: 'relative',
        },
        rootScrolled: {
            position: 'fixed',
        },
        rootLeft: {
            display: 'flex',
            alignItems: 'center',
        },
        rootCenter: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
        },
        rootMobileCenter: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            width: '100%'
        },
        rootRight: {},
        icon: {
            width: '40px',
            height: '40px',
            marginRight: '.5rem'
        },
        mainText: {
            fontWeight: 800,

        },
        tnc: {
            fontSize: '12px',
            paddingRight: '20px'
        },
        closeIcon: {
            width: '16px',
            height: '16px',
            cursor: 'pointer',
        }
    })
))



const StaticHeaderBar:React.FC<StaticHeaderBarProps> = observer((props) => {
    const classes = StaticBarStyles();
    const {i18n} = useTranslation();
    const [isScrolled, setIsScrolled] = useState(false);
    const { mbMatches } = useMedia()
    
    
    const mgmCode = 'RHKWAN52657';

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className={`${isScrolled ? classes.rootScrolled : classes.rootUnScrolled} ${classes.root}`}>
            <div className={classes.rootLeft}>
                <img className={classes.icon} src={Static_Bar_icon} alt="" />
            </div>
            <div className={mbMatches ? classes.rootMobileCenter : classes.rootCenter}>
                <div className={classes.mainText}>
                    <span>{i18n.t('portal:StaticBarTextLeft')}{props.mgmCode}{i18n.t('portal:StaticBarTextRight')}</span>
                </div>
                <div className={classes.tnc}>
                    <span>{i18n.t('portal:StaticBarTNC')}</span>
                </div>
            </div>
            <div className={classes.rootRight}>
                <img className={classes.closeIcon} onClick={props.close} src={Static_Bar_cross} alt="" />
                {/* <FontAwesomeIcon className={classes.closeIcon} icon={faXmark} style={{color: "#ffffff", fontSize: '1.5rem'}} /> */}
            </div>
        </div>
    )
})

export default StaticHeaderBar;